/**
 * @generated SignedSource<<c1e39599beec3523436743e868d3eb06>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingModal_note$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"AskFellowHooks_useAskFellowButton_note" | "MeetingContent_note">;
  readonly " $fragmentType": "MeetingModal_note";
};
export type MeetingModal_note$key = {
  readonly " $data"?: MeetingModal_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingModal_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingModal_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingContent_note"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AskFellowHooks_useAskFellowButton_note"
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "50bb964a62bab5fff4c3e34919ebf147";

export default node;
